import React, { useState, createContext } from 'react'

export const GlobalIsBlockedContext = createContext();

const GlobalIsBlockedContextProvider = (props) => {
  const [getGlobalIsBlocked, setGlobalIsBlocked] = useState(false)

  return (
    <GlobalIsBlockedContext.Provider value={{getGlobalIsBlocked, setGlobalIsBlocked}}>
      {props.children}
    </GlobalIsBlockedContext.Provider>
  )
}

export default GlobalIsBlockedContextProvider;
